import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CheckCircle2Icon, GiftIcon } from 'lucide-react';
import { PreviewCarousel } from './PreviewCarousel';
import { bonuses, volumes } from '../data/offer';
import type { Volume } from '../types/content';
const accentStyles: Record<Volume['accent'], {
  border: string;
  text: string;
}> = {
  info: {
    border: 'border-info/30',
    text: 'text-info'
  },
  primary: {
    border: 'border-primary-soft/30',
    text: 'text-primary-soft'
  },
  highlight: {
    border: 'border-highlight/30',
    text: 'text-highlight'
  },
  danger: {
    border: 'border-danger-soft/30',
    text: 'text-danger-soft'
  }
};
export function ProductOffer() {
  return <>
      <section className="bg-surface px-4 py-16 sm:py-24" data-id="element-147" data-mp="uh7a9gd2bhjy">
        <div className="mx-auto max-w-5xl" data-id="element-148" data-mp="fjevwrj94z7c">
          <header className="text-center" data-id="element-149" data-mp="fkg6yw09plp2">
            <h2 className="font-display text-3xl font-bold text-highlight sm:text-5xl" data-id="element-150" data-mp="ki8akna9yw93">
              KIT EXPRESIÓN CORPORAL CONSCIENTE™
            </h2>
            <p className="mx-auto mt-4 max-w-4xl text-[17px] font-medium" data-id="element-151" data-mp="3ldrqpr0j2vb7">
              Tu sistema de movimiento consciente para aflojar tensiones, expresar emociones y encontrar calma.
            </p>
          </header>
          <div className="mx-auto mt-10 max-w-3xl rounded-2xl border border-primary/30 bg-canvas px-5 py-7 text-center sm:px-8" data-id="element-152" data-mp="3uey9y7ukak85">
            <p className="text-foreground-muted" data-id="element-153" data-mp="32obqz5wo36vu">
              Con el <b className="text-foreground" data-id="element-154" data-mp="32p3dzsc77wai">Método AER</b>, seguís tres pasos sencillos:
            </p>
            <p className="mt-4 font-display text-xl font-bold text-primary-soft sm:text-3xl" data-id="element-155" data-mp="2xrbiypg9bu23">
              AFLOJAR <span className="text-highlight" aria-hidden="true" data-id="element-156" data-mp="3bi6nxqnmxr0e">→</span> EXPRESAR <span className="text-highlight" aria-hidden="true" data-id="element-157" data-mp="36p3xvsi2gzoy">→</span> RECONECTAR
            </p>
            <p className="mt-4 text-sm text-foreground-subtle sm:text-base" data-id="element-158" data-mp="2izj74nfo8y54">
              Sin coreografías. Sin equipamiento especial. Sin tener que inventar tus propias rutinas.
            </p>
          </div>
          <h3 className="mt-12 text-center font-display text-2xl font-bold" data-id="element-159" data-mp="hxtpm170xekd">
            📚 3 VOLÚMENES COMPLETOS
          </h3>
          <div className="mt-7 space-y-5" data-id="element-160" data-mp="mv3b55ral62x">
            {volumes.map((volume, index) => {
            const accent = accentStyles[volume.accent];
            return <motion.article key={volume.title} initial={{
              opacity: 0,
              y: 16
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.06
            }} className={`flex gap-5 rounded-2xl border ${accent.border} bg-canvas p-5 sm:p-7`} data-id="element-161" data-mp="wm7qi6kvqsya" data-mpi={index}>
                  <BookOpenIcon className={`mt-1 h-7 w-7 shrink-0 ${accent.text}`} aria-hidden="true" data-id="element-162" data-mp="dxsybfytt8vw" />
                  <div className="flex-1" data-id="element-163" data-mp="1kbsckycby6bs">
                    <p className={`text-xs font-bold tracking-brand ${accent.text}`} data-id="element-164" data-mp="1kf6btxpp5zf0">
                      {volume.label}
                    </p>
                    <h4 className="mt-1 font-display text-lg font-bold sm:text-xl" data-id="element-165" data-mp="39sxke9ih4f5i">
                      {volume.title}
                    </h4>
                    <p className="mt-1 text-sm font-semibold tracking-label text-foreground-subtle" data-id="element-166" data-mp="34wyzivwctf9u">
                      {volume.subtitle}
                    </p>
                    <ul className="mt-4 space-y-2" data-id="element-167" data-mp="2v49uojvb6znh">
                      {volume.items.map(item => <li key={item} className="flex gap-2 text-sm leading-relaxed text-foreground-muted sm:text-base" data-id="element-168" data-mp="2q6899saeuo8u">
                          <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-primary-soft" aria-hidden="true" data-id="element-169" data-mp="2m3lb79n5c737" />
                          {item}
                        </li>)}
                    </ul>
                    <p className="mt-5 border-t border-foreground/10 pt-4 text-sm sm:text-base" data-id="element-170" data-mp="2c7rsf8iu3hcz">
                      <span className="font-semibold text-foreground-subtle" data-id="element-171" data-mp="fdewp390isc9">Resultado: </span>
                      <span className={`font-bold italic ${accent.text}`} data-id="element-172" data-mp="ag579nlmigof">{volume.result}</span>
                    </p>
                  </div>
                </motion.article>;
          })}
          </div>
        </div>
      </section>
      <PreviewCarousel data-id="element-173" data-mp="386azb1pckql4" />
      <section className="bg-canvas px-4 py-16 sm:py-24" data-id="element-174" data-mp="2u8w75p7pm4pg">
        <div className="mx-auto max-w-5xl" data-id="element-175" data-mp="2u8e3i7ipwo7i">
          <header className="text-center" data-id="element-176" data-mp="2z7h0r5sghq4x">
            <GiftIcon className="mx-auto h-10 w-10 text-highlight" aria-hidden="true" data-id="element-177" data-mp="2z65vf1jd4abp" />
            <h2 className="mt-3 font-display text-3xl font-bold text-highlight sm:text-5xl" data-id="element-178" data-mp="2ki197nl3pgo6">
              5 BONOS DE REGALO
            </h2>
          </header>
          <div className="mt-10 space-y-4" data-id="element-179" data-mp="2biejw05nc1bh">
            {bonuses.map(({
            number,
            title,
            detail,
            items,
            value
          }) => <article key={number} className="flex flex-col gap-4 rounded-2xl border border-highlight/20 bg-surface p-5 sm:flex-row sm:items-start sm:p-7" data-id="element-180" data-mp="2gf4u46urs2oz">
                <span className="w-fit whitespace-nowrap rounded-lg bg-highlight/10 px-3 py-2 font-bold text-highlight" data-id="element-181" data-mp="26i08q98r0b98">
                  🎁 BONO {number}
                </span>
                <div className="flex-1" data-id="element-182" data-mp="1iw6b326uk6r7">
                  <h3 className="font-bold" data-id="element-183" data-mp="1ixhgf6fxxmkf">{title}</h3>
                  {detail && <p className="mt-2 text-sm leading-relaxed text-foreground-muted" data-id="element-184" data-mp="1wvphnqk0fa1e">
                      {detail}
                    </p>}
                  <ul className="mt-3 space-y-1.5" data-id="element-185" data-mp="1ryfmrvduq666">
                    {items.map(item => <li key={item} className="flex gap-2 text-sm leading-relaxed text-foreground-muted" data-id="element-186" data-mp="25ut494idy7kn">
                        <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0 text-highlight" aria-hidden="true" data-id="element-187" data-mp="21u0tu7xs1wms" />
                        {item}
                      </li>)}
                  </ul>
                </div>
                <div className="flex shrink-0 items-center gap-3" data-id="element-188" data-mp="2anm6nlqdt3tk">
                  <span className="text-xs font-semibold text-foreground-faint" data-id="element-189" data-mp="2pl68wkvw8kw1">VALOR:</span>
                  <span className="text-sm text-foreground-faint line-through" data-id="element-190" data-mp="2km332y83aan0">
                    {value}
                  </span>
                  <span className="rounded-full bg-primary-soft px-3 py-1 text-sm font-bold text-canvas" data-id="element-191" data-mp="2rq1h2xsuioln">
                    GRATIS
                  </span>
                </div>
              </article>)}
          </div>
          <div className="mt-8 rounded-2xl border border-highlight/30 bg-highlight/10 p-6 text-center" data-id="element-192" data-mp="31kl2yd21kc6t">
            <p className="text-xs font-bold tracking-brand text-highlight" data-id="element-193" data-mp="36exkuinvdfgg">
              VALOR TOTAL DE LOS BONOS
            </p>
            <p className="mt-1 text-2xl font-bold text-foreground-subtle line-through" data-id="element-194" data-mp="3fd19voy2cud0">
              $52.000
            </p>
            <p className="mt-2 font-display text-xl font-bold text-highlight" data-id="element-195" data-mp="3ke72znvmyjn2">
              GRATIS con tu Kit Expresión Corporal Consciente™
            </p>
          </div>
        </div>
      </section>
    </>;
}